export const LOCALE_HEADER = "x-api-client-locale";
